import { Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  fetchProyectoById,
  fetchProyectoByIdGrafica,
  limpiarProyecto,
} from "../../../actions/proyecto";
import Accordion from "../../../components/accordion";
import Bread from "../../../components/breadcrumb";
import { routeProyectoInfo } from "../../../utils/routesBread";
import AccordionProyecto from "../accordion-proyecto";
import DialogCustom from "../../../components/dialog";
import InfoTarjeta from "../../tarjeta/info-tarjeta";
import FormProyecto from "../form";
import AccordionObjetivos from "../../../components/acordion-objetivos";
import Tab from "../../../components/tab";
import SankeyContainer from "../../../components/sankey/SankeyContainer";

const InfoProyecto = () => {
  const [openTarjetaModal, setOpenTarjetaModal] = useState(false);
  const [tarjetaSeleccionada, setTarjetaSeleccionada] = useState(null);
  const { proyecto, isLoading } = useSelector((state) => state.proyectoReducer);
  const [form, setForm] = useState({
    nombre: "",
    descripcion: "",
    area: "",
    linea: "",
    empresa: "",
    proceso: "",
    identificacion: "",
    tipo: "",
  });
  const [disabled, setDisabled] = useState(true);
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchProyectoById(id));
    return () => {
      dispatch(limpiarProyecto());
    };
  }, []);

  useEffect(() => {
    setForm({
      nombre: proyecto && proyecto.nombre,
      descripcion: proyecto && proyecto.descripcion,
      area: proyecto && proyecto.area,
      linea: proyecto && proyecto.linea,
      empresa: proyecto && proyecto?.empresa?.nombre,
      proceso: proyecto && proyecto.proceso,
      identificacion: proyecto && proyecto.identificacion,
      tipo: proyecto && proyecto.tipo,
    });
  }, [proyecto]);

  useEffect(() => {
    const intervalId = setInterval(
      () => dispatch(fetchProyectoByIdGrafica(id)),
      30000
    );
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <div>
      <div className="header-nav">
        <Bread routes={routeProyectoInfo} />
      </div>
      <div className="info-container">
        {isLoading ? (
          <div className="container-spin">
            <Spin tip="Cargando..." />
          </div>
        ) : (
          <>
            {proyecto && isLoading === true ? (
              <p className="info-container__nothing">
                Los detalles del proyecto no se encontrarón
              </p>
            ) : (
              <>
                {form && (
                  <FormProyecto
                    data={form}
                    disabled={disabled}
                    setDisabled={setDisabled}
                  />
                )}
                <AccordionObjetivos />
                <AccordionProyecto
                  data={proyecto}
                  onInfoTarjeta={(tarjeta) => {
                    setTarjetaSeleccionada(tarjeta);
                    setOpenTarjetaModal(true);
                  }}
                />
                
                {/* Nueva sección de Gráfica Sankey del Proyecto */}
                {proyecto && (
                  <div className="info-container__grafica">
                    <Accordion header="Análisis de Flujo de Datos (Sankey)" keyPanel="sankey-proyecto">
                      <SankeyContainer
                        type="proyecto"
                        id={id}
                        title={`Flujo de Datos - ${proyecto.nombre || 'Proyecto'}`}
                        showControls={true}
                        initialParams={{
                          limite: 60,
                          unidades: [],
                          incluirInactivos: false
                        }}
                        controlsConfig={{
                          showUnidadesFilter: true,
                          showLimiteControl: true,
                          showInactivosToggle: true
                        }}
                      />
                    </Accordion>
                  </div>
                )}

                <DialogCustom
                  open={openTarjetaModal}
                  onClose={() => setOpenTarjetaModal(false)}
                  title={
                    tarjetaSeleccionada?.nombre
                      ? `Tarjeta: ${tarjetaSeleccionada.nombre}`
                      : "Tarjeta"
                  }
                  maxWidth="md"
                >
                  {tarjetaSeleccionada && (
                    <InfoTarjeta tarjeta={tarjetaSeleccionada} />
                  )}
                </DialogCustom>
                <div className="info-container__grafica">
                  <Accordion header="Graficas" keyPanel="grafica">
                    {(proyecto?.graficas || proyecto?.graficaSankey) && (
                      <Tab
                        dataGrafica={proyecto?.graficas}
                        dataSankey={proyecto?.graficasSankey}
                      />
                    )}
                  </Accordion>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default InfoProyecto;